export default "__VITE_ASSET__BqcV7JLg__"